import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditDepartement = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [departementData, setDepartementData] = useState({});
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [OpenAlert, setOpenAlert] = useState(false);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [departementValue, setDepartementValue] = useState('');
  const [country, setCountry] = useState('');
  const [region, setRegion] = useState('');
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...departementData };
    item[name] = value;
    if (name === 'country') {
      setCountry(value);
    }
    if (name === 'region') {
      console.log('debug', value);
      setRegion(value);
    }
    setDepartementData(item);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (departementData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        departementData['name'] = props.departement['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        departementData['region'] = JSON.parse(region);
        const response = httpClient.current?.put(`/api/departement/update`, departementData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.departements();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      console.log(error);
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    departementData['name'] = props.departement['name'];
    departementData['region'] = props.departement['region'];
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    setDepartementData(props.departement);
    setCountry(JSON.stringify(props.departement['region']['country']));
    setRegion(JSON.stringify(props.departement['region']));
    setSelectedCountry(JSON.stringify(props.departement['region']['country']));
  }, [props.departement]);
  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient, selectedCountry]);

  useEffect(() => {
    const getRegions = () => {
      if (!selectedCountry) return;
      httpClient.current?.get(`/api/region/all`).then((response) => {
        let regions = response.data;
        regions = regions.filter((region) => region.country.id === JSON.parse(selectedCountry).id);
        setRegions(regions);
      });
    };
    getRegions();
  }, [selectedCountry, httpClient]);

  return (
    <>
      <EditButtonIcon
        title={props.t('update_departement')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_departement')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={departementData['name']}
                    onChange={(event) => setDepartementValue(event.target.value)}
                    placeholder={props.t('placeholder_departement_name')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select
                    name="country"
                    id="country"
                    className="form-control"
                    value={country}
                    onChange={(event) => {
                      setSelectedCountry(event.target.value);
                      setRegion('');
                    }}
                  >
                    <option value="">{props.t('select_country_name')}</option>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'region_name'}>{props.t('region_name')}</label>
                  <select
                    name="region"
                    id="region"
                    className="form-control"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                  >
                    <option value="">{props.t('select_region_name')}</option>
                    {regions.map((region, index) => (
                      <option id={region.id} key={index} value={JSON.stringify(region)}>
                        {region.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={UpdateModalToggle}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditDepartement);
